import React from "react";
import "components/InterviewerListItem.scss";

import classNames from 'classnames';

// InterviewerListItem component - individual interviewers, highlighted if selected
export default function InterviewListItem(props) {

  const interviewerClass = classNames('interviewers__item', {
    'interviewers__item--selected': props.selected,
  });
  
  return (
    <li className={interviewerClass} onClick={props.setInterviewer}>
    <img
      className="interviewers__item-image"
      src={props.avatar}
      alt={props.name}
    />
    {props.selected && props.name}
  </li>
  );
}
